const baseStyleHelperText = {
    fontSize: "sm",
    lineHeight: "base",
    fontWeight: "normal",
    color: "greyscale.600",
};
const baseStyle = {
    helperText: baseStyleHelperText,
};
const Form = {
    baseStyle,
};
export default Form;
